import { API_URL } from "../utils/AppApiUrl";
import { postWithHeaders } from "../utils/httpClients-methods";
import tokenHttpClient from "../utils/httpClient";
const baseUrl = process.env.REACT_APP_BASE_URL;

export const validateData = async (baseUrl, request) => {
  const APIURL = `${baseUrl}${API_URL.validateData}`;
  try {
    const headers = {
      "Validate-Request": "VALIDATE_PO_ASN",
    };

    const requestBody = {
      ...request,
    };

    const response = await postWithHeaders(tokenHttpClient, APIURL, requestBody, headers);

    if (response.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const configReadAPIService = async (requestBody, headers) => {
  try {
    const apiURL = `${baseUrl}${API_URL.configMaster}`;
    const response = await postWithHeaders(
      tokenHttpClient,
      apiURL,
      requestBody,
      headers
    );

    if (response.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getConfigService = async (requestBody, headers) => {
  try {
    const apiURL = `${baseUrl}${API_URL.appointmentConfigURL}`;
    const response = await postWithHeaders(
      tokenHttpClient,
      apiURL,
      requestBody,
      headers
    );

    if (response.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};
